<section class="bg-white">
    <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
       
        <h1 class="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl">HobbsTechsolutely</h1>
        <p class="mb-8 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 xl:px-48">Strength in Partnership</p>
        <div class="flex flex-col mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4">
       
            <a href="https://hobbstech.co.zw/" target="_blank" class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100">
                Visit HobbsTech
            </a>  
            <a href="https://techsolutely.co.zw/" target="_blank" class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100">
                Visit Techsolutely
            </a>  
        </div>
     
    </div>
</section>
<section class="bg-gray-900">
    <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div class="max-w-screen-lg text-gray-300 sm:text-lg">
            <h2 class="mb-4 text-4xl tracking-tight font-bold text-white">About HobbsTechsolutely</h2>
            <p class="mb-4 font-light">HobbsTechSolutely is a partnership between HobbsTech and TechSolutely that provides a full suite of technology. Our team is full of experienced engineers, program managers, and other commercial tech professionals who love bringing scalable solutions to life as much as they love working with clients to solve problems.</p>
            <p class="mb-4 font-medium">It’s this rare combination that makes us excel at what we do.</p>
            <a href="https://techsolutely.co.zw/" target="_blank" class="inline-flex items-center font-medium text-primary-600 hover:text-primary-800 ">
               Visit Techsolutely
                <svg class="ml-1 w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
            </a>
            <a href="https://hobbstech.co.zw/" target="_blank" class="inline-flex items-center font-medium text-primary-600 hover:text-primary-800 ">
               Visit Hobbstech
                <svg class="ml-1 w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
            </a>
        </div>
    </div>
  </section>

  <section class="bg-white text-gray-900">
    <div class="max-w-screen-xl mx-auto px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
      <div class="max-w-xl">
        <h2 class="text-3xl font-bold sm:text-4xl">Our skills</h2>
  
        
      </div>
  
      <div class="mt-8 grid grid-cols-1 gap-8 md:mt-16 md:grid-cols-2 md:gap-12 lg:grid-cols-3">
        <div class="flex items-start gap-4">
          <span class="shrink-0 rounded-lg bg-gray-800 p-4">
            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"/></svg>
          </span>
  
          <div>
            <h2 class="text-lg font-bold">Development</h2>
  
            <p class="mt-1 text-sm text-gray-500">
                Is it code? Do you want to upgrade or start from stratch? Then we do it. Wonderful web sites, database design, modern mobile apps, and rockin’ restful APIs; we’ve got you.
            </p>
          </div>
        </div>
  
        <div class="flex items-start gap-4">
          <span class="shrink-0 rounded-lg bg-gray-800 p-4">
            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"/></svg>
          </span>
  
          <div>
            <h2 class="text-lg font-bold">Design</h2>
  
            <p class="mt-1 text-sm text-gray-500">
                A crisp, beautiful interface brings us great joy. We have a passion for building gorgeous, responsive, applications. Everything we do really good looks while it’s easy to use and navigate.
            </p>
          </div>
        </div>
  
        <div class="flex items-start gap-4">
          <span class="shrink-0 rounded-lg bg-gray-800 p-4">
            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7l131.7 0c0 0 0 0 .1 0l5.5 0 112 0 5.5 0c0 0 0 0 .1 0l131.7 0c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2z"/></svg>
          </span>
  
          <div>
            <h2 class="text-lg font-bold">Management</h2>
  
            <p class="mt-1 text-sm text-gray-500">
                We’ve got your IT project under control. We know what it takes to take a project from start to finish and our experience leads the way.
            </p>
          </div>
        </div>
  
        <div class="flex items-start gap-4">
          <span class="shrink-0 rounded-lg bg-gray-800 p-4">
            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160l0 96 192 0 128 0 192 0 0-96c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM512 288l-192 0 0 32c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-32L0 288 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128z"/></svg>
          </span>
  
          <div>
            <h2 class="text-lg font-bold">Business</h2>
  
            <p class="mt-1 text-sm text-gray-500">
                Your business is our business. We’re great with code and design but we know everything we do is working towards your business goals. We keep that in mind every step of the way.
            </p>
          </div>
        </div>
  
      </div>
    </div>
    <div class="max-w-screen-xl mx-auto px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
      <div class="max-w-xl">
        <h2 class="text-3xl font-bold sm:text-4xl">Our Values</h2>
  
        
      </div>
  
      <div class="mt-8 grid grid-cols-1 gap-8 md:mt-16 md:grid-cols-2 md:gap-12 lg:grid-cols-3">
        <div class="flex items-start gap-4">
          <span class="shrink-0 rounded-lg bg-gray-800 p-4">
            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"/></svg>
          </span>
  
          <div>
            <h2 class="text-lg font-bold">Client First</h2> 
          
          </div>
        </div>
  
        <div class="flex items-start gap-4">
          <span class="shrink-0 rounded-lg bg-gray-800 p-4">
            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"/></svg>
          </span>
  
          <div>
            <h2 class="text-lg font-bold">Great team</h2>
  
          
          </div>
        </div>
  
        <div class="flex items-start gap-4">
          <span class="shrink-0 rounded-lg bg-gray-800 p-4">
            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"/></svg>
          </span>
  
          <div>
            <h2 class="text-lg font-bold">Growth orientated</h2>
  
           
          </div>
        </div>
  
   
  
      </div>

      <div class="flex justify-center items-center gap-2 my-8">
        <a href="https://hobbstech.co.zw/" target="_blank">
            <img src="assets/hobbstech.png" class="h-24" alt="hobbstech">

        </a>
        <a href="https://techsolutely.co.zw/" target="_blank" >
            <img src="assets/techsolutely.png" class="h-20" alt="techsolutely">

        </a>
      </div>
    </div>
  </section>